import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TreatmentPlanUpdateModalComponent } from 'src/app/core/components/wylo/visits/treatment-plan-update-modal/treatment-plan-update-modal.component';
import { VisitService } from 'src/app/core/services/wylo-services/visit.service';

@Component({
  selector: 'app-confirmation-rx-before-create',
  templateUrl: './confirmation-rx-before-create.component.html',
  styleUrl: './confirmation-rx-before-create.component.scss'
})
export class ConfirmationRxBeforeCreateComponent {
  editMode = false;
  note_id: any;
  noteForm!: FormGroup;
  isLoading = false;
  title: any;
  minDate = new Date();
  titleStatus = 'change';
  titleStatusCp = 'Enable';
  titleStatusCpLoding = 'Enabling...';
  status: number = 0;
  treatmentPlan: any = [];
  constructor(
    public dialogRef: MatDialogRef<ConfirmationRxBeforeCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private visitService: VisitService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // console.log(this.data)
    // setTimeout(()=>{
    // this.getTreatmentPlan(this.data);
    // },100)
  }

  submitForm() {
    this.dialogRef.close(true);
  }

}
